import { NodeDefinition } from 'Automations/nodeDefinitions/types'
import { ActionType } from '..'
import { ActionEditorNode } from '../action.editorNode'
import { ActionContractExtractionNodeConfigForm } from './actionContractExtraction.configForm'
import { ActionIcon } from '../action.icon'
import { actionTypeRequired, handlesConnected } from '../action.validators'
import {
  createSimpleTask,
  getTaskReferenceName,
  wrapVariables
} from 'Automations/nodeDefinitions/conductor'
import {
  getClosestMatches,
  semanticTypes
} from 'Automations/nodeDefinitions/semanticTypes'
import { ContractExtractionExecutionSummary } from './ContractExtraction.executionSummary'
import { TASK_EXECUTORS } from 'Automations/automations.constants'

export type Config = {
  name: string
  actionType: ActionType
}

type Inputs = 'assetId'

type Outputs = 'billingSchedule' | 'contract' | 'customer'

type TaskName = 'extractContract'

const taskReferenceBuilder = getTaskReferenceName<TaskName>(
  'ACTION_CONTRACT_EXTRACTION'
)

export const actionContractExtractionNodeDefinition: NodeDefinition<
  Config,
  Inputs,
  Outputs
> = {
  name: 'Action',
  description: 'Contract extraction',
  editorNode: ActionEditorNode,
  configForm: ActionContractExtractionNodeConfigForm,
  icon: ActionIcon,
  defaultConfig: {
    name: '',
    actionType: 'CONTRACT_EXTRACTION'
  },
  validation: {
    node: { ERROR: [], WARN: [] },
    config: {
      name: { ERROR: [], WARN: [] },
      actionType: { ERROR: [actionTypeRequired], WARN: [] }
    },
    handles: { ERROR: [handlesConnected], WARN: [] }
  },
  inputMapping: ({ upstreamNodes }) => {
    return getClosestMatches<Inputs>(upstreamNodes)({
      assetId: semanticTypes.sequence.asset.id
    })
  },
  outputMapping: nodeId => {
    const taskReferenceName = taskReferenceBuilder(nodeId)

    return {
      billingSchedule: {
        id: `${taskReferenceName('extractContract')}.output.extractedData.billingSchedule`,
        semanticType: semanticTypes.sequence.billingSchedule
      },
      contract: {
        id: `${taskReferenceName('extractContract')}.output.extractedData.contract`,
        semanticType: semanticTypes.sequence.contract.fullContract
      },
      contractName: {
        id: `${taskReferenceName('extractContract')}.output.extractedData.contract.name`,
        semanticType: semanticTypes.sequence.contract.name
      },
      customer: {
        id: `${taskReferenceName('extractContract')}.output.extractedData.customer`,
        semanticType: semanticTypes.sequence.customer.customer
      }
    }
  },
  taskTransformer: ({ nodeId, inputMapping }) => {
    const taskReferenceName = taskReferenceBuilder(nodeId)

    return [
      createSimpleTask({
        name: 'extract_contract',
        taskReferenceName: taskReferenceName('extractContract'),
        inputParameters: {
          taskExecutorConfiguration: {
            version: 1,
            executor: TASK_EXECUTORS.extractContract
          },
          data: wrapVariables({
            assetId: inputMapping.assetId
          })
        }
      })
    ]
  },
  executionSummary: ContractExtractionExecutionSummary
}
